import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { assign, trim } from 'lodash';

@Component({
  selector: 'app-edit-seeder-group-data',
  templateUrl: './edit-seeder-group-data.component.html',
  styleUrls: ['./edit-seeder-group-data.component.scss']
})
export class EditSeederGroupDataComponent implements OnInit {

    private _groupData: any;

    groupDataFormGroup: FormGroup;

    constructor(
        private _dialogRef: MatDialogRef<any>,
        private _fb: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: any) {}

    ngOnInit() {

        // Init food config initial value
        this._groupData = assign({}, this.data);

        this.groupDataFormGroup = this._fb.group({
            name: [this._groupData.name, [
                Validators.required
            ]],
            address: [this._groupData.address, [
                Validators.required
            ]],
            description: [this._groupData.description, [
                Validators.required
            ]]
        });

    }

    dialogSaveActionIsEnabled() {

        return !this.groupDataFormGroup.pristine && this.groupDataFormGroup.valid;

    }

    onSaveGroup() {

        this._groupData.name = trim(this.groupDataFormGroup.get('name').value);
        this._groupData.address = trim(this.groupDataFormGroup.get('address').value);
        this._groupData.description = trim(this.groupDataFormGroup.get('description').value);

        this._dialogRef.close(this._groupData);

    }

    onCancel() {

        this._dialogRef.close();

    }

}



// WEBPACK FOOTER //
// ./src/app/components/modals/edit-seeder-group-data/edit-seeder-group-data.component.ts